import Image1 from '../Images/kitchen--cleaning.png'
import Image2 from '../Images/car-cleaning.jpg'
import Image3 from '../Images/blind-cleaning.jpg'
import Image4 from '../Images/floor-cleaning.jpg'
import Image5 from '../Images/floor-cleaning-2.jpg'
import Image6 from '../Images/kitchen-cleaning.jpg'
import Image7 from '../Images/kitchen-cleaning-2.jpg'
import Image8 from '../Images/toilet-cleaning.jpg'
import Image9 from '../Images/vaccum-cleaner.jpg'
import Image10 from '../Images/vaccum-cleaning.jpg'
import Image11 from '../Images/waste-bin-cleaning.jpg'
import Image12 from '../Images/kitchen-machine.jpg'
const GalleryData = [
    {
    id: 1,
    image: Image1
    },
    {
    id: 1,
    image: Image2
    },
    {
    id: 1,
    image: Image3
    },
    {
    id: 1,
    image: Image4
    },
    {
    id: 1,
    image: Image5
    },
    {
    id: 1,
    image: Image6
    },
    {
    id: 1,
    image: Image7
    },
    {
    id: 1,
    image: Image8
    },
    {
    id: 1,
    image: Image9
    },
    {
    id: 1,
    image: Image10
    },
    {
    id: 1,
    image: Image11
    },
    {
    id: 1,
    image: Image12
    }

]

export default GalleryData;